var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"author-line"},[(_vm.prefix)?[_vm._v(" "+_vm._s(_vm.prefix)+" ")]:_vm._e(),(_vm.date)?[_vm._v(" "+_vm._s(_vm.formatDateDuration(_vm.date))+" ("+_vm._s(_vm.formatDate(_vm.date))+") ")]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }